import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AdvanceSearchComponent} from '../A2-utils/advance-search/advance-search.component';
import {AdvanceSearchStateService} from 'app/services/advance-search-state.service';

@Component({
  selector: 'app-merge-account',
  templateUrl: './merge-account.component.html',
  styleUrls: ['./merge-account.component.scss']
})
export class MergeAccountComponent implements OnInit, OnDestroy {

  protected searcheToMerge: any;
  protected ridesSelected: any[] = [];
  protected reloadGrid = false;
  protected sub: any;
  enabledBtn;

  @ViewChild(AdvanceSearchComponent) private advanceSearch: AdvanceSearchComponent;
  @ViewChild('search') search: AdvanceSearchComponent;

  constructor(private route: ActivatedRoute, private router: Router, private searchStateService: AdvanceSearchStateService) {
  }
  ngOnInit() {
    this.sub = this.route.params.subscribe(
      params => {
        if (params['search'] !== undefined) {
          this.searcheToMerge = params;
        } else {
          const savedCriteria = this.searchStateService.currentCriteria;
          this.searcheToMerge = savedCriteria
            ? Object.assign({}, savedCriteria.importSearch)
            : {
              search: '',
              searchtype: 'Payor',
              payorid: 0,
              isbasic: true
            };
        }
      }
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  onAccountsToMerge(event) {
    this.ridesSelected = event;
  }

  /**
   * RELOAD THE GRID OF THE ADVANCE SEARCH COMPONENT
   */
  onReloadSearchGrid() {
    this.advanceSearch.reloadGrid();
  }

  backToReservation() {
    this.router.navigateByUrl('/pages/reservation');
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/merge-account/merge-account.component.ts